import { styled, Tooltip, TooltipProps } from '@mui/material';

export const ActionTooltip = styled((props: TooltipProps) => (
  <Tooltip
    placement="top"
    slotProps={{
      popper: {
        modifiers: [
          {
            name: 'offset',
            options: {
              offset: [0, -16],
            },
          },
        ],
      },
    }}
    {...props}
  />
))({});
